/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */

export type PermissionKey = (typeof PermissionKey)[keyof typeof PermissionKey];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PermissionKey = {
  USER_MANAGEMENT: "USER_MANAGEMENT",
  ASSIGN_ROLES: "ASSIGN_ROLES",
  ADD_ROLES: "ADD_ROLES",
  GLOBAL_PERMISSIONS: "GLOBAL_PERMISSIONS",
  MANAGE_TENANT: "MANAGE_TENANT",
  CREATE_PROJECT: "CREATE_PROJECT",
  EDIT_PROJECT_STRUCTURE: "EDIT_PROJECT_STRUCTURE",
  PHASES_MILESTONES: "PHASES_MILESTONES",
  DELIVERABLES: "DELIVERABLES",
  TASKS: "TASKS",
  CONFIGURE_PRELOAD_GLOBAL: "CONFIGURE_PRELOAD_GLOBAL",
  APPLY_PRELOAD_PROJECT: "APPLY_PRELOAD_PROJECT",
  EDIT_CHECKPOINTS: "EDIT_CHECKPOINTS",
  EDIT_AUDIT_PLANS: "EDIT_AUDIT_PLANS",
  DOCUMENT_AUDIT_RESULTS: "DOCUMENT_AUDIT_RESULTS",
  RELEASE_AUDIT_PLANS: "RELEASE_AUDIT_PLANS",
  MANAGE_DEPENDENCIES: "MANAGE_DEPENDENCIES",
  TRIGGER_SCHEDULING: "TRIGGER_SCHEDULING",
  CREATE_ACTION_ITEMS: "CREATE_ACTION_ITEMS",
  ASSIGN_ACTION_ITEMS: "ASSIGN_ACTION_ITEMS",
  CREATE_RISK_MATRIX: "CREATE_RISK_MATRIX",
  CAPTURE_RISKS: "CAPTURE_RISKS",
  PLAN_RESOURCES: "PLAN_RESOURCES",
  CAPTURE_OWN_EFFORT: "CAPTURE_OWN_EFFORT",
  REVIEW_RELEASE_EFFORT: "REVIEW_RELEASE_EFFORT",
  SAVE_TEMPLATES: "SAVE_TEMPLATES",
  CUSTOMIZE_ENTRY_SCREEN: "CUSTOMIZE_ENTRY_SCREEN",
  CONFIGURE_REPORTING: "CONFIGURE_REPORTING",
  CUSTOMIZE_COLORS: "CUSTOMIZE_COLORS",
  INTERFACES_API: "INTERFACES_API",
  VIEW_AUDIT_TRAIL: "VIEW_AUDIT_TRAIL",
  EDIT_AUDIT_TRAIL: "EDIT_AUDIT_TRAIL",
} as const;
